export default __webpack_public_path__ + "static/media/b4f3e44e88c70767a1a83d8e848fc4e6.svg";